<script setup>
import { ref } from 'vue'
import BatchConfig from './batchConfig/BatchConfig.vue'
import OfflineTime from './offlineTime/OfflineTime.vue'

const tab_active = ref('1')
function handleClick(tab) {
    tab_active.value = tab.name
}
</script>

<template>
    <el-tabs class="elTabs" v-model="tab_active" @tab-click="handleClick">
        <el-tab-pane label="批量配置" name="1" lazy>
            <batch-config />
        </el-tab-pane>
        <el-tab-pane label="全局配置" name="2" lazy>
            <offline-time />
        </el-tab-pane>
    </el-tabs>
</template>

<style scoped lang="scss">
.elTabs {
    height: 100%;
    :deep(.el-tabs__nav-scroll) {
        padding-left: 15px;
    }
    :deep(.el-tabs__nav-wrap:after) {
        display: none;
    }
    :deep(.el-tabs__content) {
        height: 100%;

        .el-tab-pane {
            height: 100%;
        }
    }
}
</style>
